import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'tpl-one-to-five-scale',
  templateUrl: './tpl-one-to-five-scale.component.html',
  styleUrls: ['./tpl-one-to-five-scale.component.sass']
})
export class TplOneToFiveScaleComponent implements OnInit {
  numbers: number[] = [1, 2, 3, 4, 5]
  @Input() form: FormGroup;
  @Input() objColor: any;
  @Input() low_score_label: string;
  @Input() high_score_label: string;
  @Output() nextStep = new EventEmitter<string>();

  constructor() { }

  timer;

  ngOnInit(): void {
  }

  setFormValue(number){
    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.nextStep.emit('');
    }, 1000);
    this.form.get('value').setValue(number);
  }

}